(function() {
  'use strict';

  angular
    .module('service.quizFactory', ['service.quiz'])
    .factory('QuizServiceFactory', QuizServiceFactory);

  QuizServiceFactory.$inject = ['$injector'];

  function QuizServiceFactory($injector) {
    return {
      getQuizService: function getQuizService(isPreview) {
        return isPreview ? $injector.get('PreviewQuizService') : $injector.get('QuizService');
      }
    };
  }
})();
